export const APP_LOCALE = 'APP_LOCALE';
export const ACCESS_TOKEN = 'ACCESS_TOKEN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const INTERVAL_TO_REFETCH_FAILED_CONTEXT_DATA = 5000;
